/**
 * Persists mandatory PDP gift selections (auto-add offers) in sessionStorage.
 * Optional promptToAdd picks on the PDP are not stored here — they apply on add-to-cart only.
 */
(function (global) {
  if (global.FreeGiftSelection) return;

  const STORAGE_KEY = 'free-gift-controller:selections';

  function readAll() {
    try {
      const raw = global.sessionStorage?.getItem(STORAGE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }

  function writeAll(data) {
    try {
      global.sessionStorage?.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {
      /* ignore quota / private mode */
    }
  }

  function get(offerId) {
    if (offerId == null) return null;
    const all = readAll();
    const entry = all[String(offerId)];
    if (!entry || typeof entry !== 'object') return null;
    return Array.isArray(entry) ? entry : null;
  }

  function set(offerId, entries) {
    if (offerId == null) return;
    const all = readAll();
    const normalized = (Array.isArray(entries) ? entries : [])
      .map((item) => ({
        variantId: Number(item?.variantId),
        quantity: Number(item?.quantity) || 0,
        productId: item?.productId != null ? Number(item.productId) : undefined,
      }))
      .filter((item) => item.variantId && item.quantity > 0)
      .map(({ variantId, quantity, productId }) =>
        productId ? { variantId, quantity, productId } : { variantId, quantity }
      );

    if (!normalized.length) {
      delete all[String(offerId)];
    } else {
      all[String(offerId)] = normalized;
    }
    writeAll(all);
  }

  function clear(offerId) {
    if (offerId == null) return;
    const all = readAll();
    delete all[String(offerId)];
    writeAll(all);
  }

  function clearAll() {
    try {
      global.sessionStorage?.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  }

  global.FreeGiftSelection = {
    get,
    set,
    clear,
    clearAll,
    getForOffer(offerId) {
      return get(offerId);
    },
  };
})(typeof window !== 'undefined' ? window : globalThis);
